module.exports = __webpack_public_path__ + "img/2W.1.1ed51e21.jpg";